/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Builtin_Name_ConflictInputs */



/**
* | output |
* | --- |
* | "That name is used by a built-in preset. Choose a different name." |
*
* @param {Standards_Preset_Builtin_Name_ConflictInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_builtin_name_conflict = /** @type {((inputs?: Standards_Preset_Builtin_Name_ConflictInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Builtin_Name_ConflictInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "de") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "it") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "es") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
	return /** @type {LocalizedString} */ ("That name is used by a built-in preset. Choose a different name.")
});